<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">单位类型</div>
          <div class="field">
            <el-select v-model="query.comtype" :clearable="true" placeholder="请选择">
            <el-option
              v-for="item in roles"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">单位名称</div>
          <div class="field">
            <el-input v-model.trim="query.comcodename" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">联系电话</div>
          <div class="field">
            <el-input v-model.trim="query.commobile" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
    {{list[0]}}
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
            @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
    <el-dialog
        title="注册审批"
        :visible.sync="dialogVisible"
        width="70%"
        :before-close="handleClose">
        <span>{{com}}</span>
        <span>
    {{list[0]}}</span>
        <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">公司名称</div>
              <div class="view-content">{{com.comfullname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">单位类型</div>
              <div class="view-value">{{com.comtypename}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">统一信用代码</div>
              <div class="view-value">{{com.comidcode}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-value">{{com.comcontact}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系电话</div>
              <div class="view-value">{{com.commobile}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-content">
                  <popover-img :img-src="append.appendurl ? uploadAddr + append.appendurl:''"
                               default-height="150"></popover-img>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">审批</div>
              <div class="view-value">
                  <el-radio-group v-model="com.cositemcomstatus" class="value" required>
                    <el-radio :label="3">通过</el-radio>
                    <el-radio :label="4">驳回</el-radio>
                  </el-radio-group>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">审批意见</div>
              <div class="view-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="com.cositemappcomm">
                  </el-input>
              </div>
            </div>
          </div>
        </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmApproval">确 定</el-button>
        </span>
      </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import popoverImg from '../common/popoverImg'
  import utils from '../../assets/js/utils'
  export default {
    name: 'zcApprove',
    data () {
      return {
        menuid: this.$route.query.menuid,
        btn:{},
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'comtypename', fieldtype: 'C', title: '单位类型',calculExpr:'', addNewRowFlg: false},
          { field: 'comfullname', fieldtype: 'C', title: '单位名称',calculExpr:'',addNewRowFlg: false},
          { field: 'comcontact', fieldtype: 'C', title: '联系人',calculExpr:'',addNewRowFlg: false},
          { field: 'commobile', fieldtype: 'C',title: '联系电话',calculExpr:'',addNewRowFlg: false},
          { field: 'comregtime', fieldtype: 'T',title: '注册日期',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'cositemapsynergywaydesc', fieldtype: 'C',title: '与代理协同方式',calculExpr:'',addNewRowFlg: false},
          { field: 'cositemcomstatusdesc', fieldtype: 'C',title: '审核状态',calculExpr:'',addNewRowFlg: false},
          {
            title: '操作 ', width: 100, showOverflow: true,
            slots: {
              default: ({row}) => {
                  return [<vxe-button onClick={this.showReview.bind(this,row)}>审核</vxe-button>]
              }}
          }
        ],
        dialogVisible:false,
        comform: false,
        com: {},
        append:{},
        query: {
          total: 0,
          limit: 20,
          offset: 0,
          comtype: ''
        },
        roles: []
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getSysCodeList()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid,popoverImg},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      init () {
        this.query = {
            total: 0,
            limit: 20,
            offset: 0,
            comtype: ''
          }
      },
      async getSysCodeList () {
        let res = await request({
          method: 'get',
          url: '/kfgl/syscode/getSysCodeList',
          params: {syscode: 'cositemcomtype'}
        })
        this.roles = res
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.com = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.com = row.row
      },
      async viewProject(row) {
        this.com = row.row
        this.$router.push({name: 'comView', params: {comid: this.com.comid,innerbtn: this.btn.inner}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      showReview(row){
        this.com = row
        this.getAppend(row)
        this.dialogVisible = true
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.Unreviewed = true
        let res = await request({
          method: 'get',
          url: '/ywgl/com/getPageList',
          params: this.query
        })
        console.log('-------res.list[0]---------',res.list[0]);
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      async getAppend(i){
        let query = {}
        query.appendfromid = i.comid
        query.appendfromtype = 1
        let res = await request({
          method: 'get',
          url: '/ywgl/append/getAppendListByFromId',
          params: query
        })
        this.append = res
      },
      async confirmApproval(){
        let model = {}
        model.comid = this.com.comid
        model.comcosid = this.com.comcosid
        model.cositemcomstatus = this.com.cositemcomstatus
        let res = await request({
          method: 'post',
          url: '/ywgl/com/confirmApproval',
          data: model
        })
        console.log('----------------9090909090',model);
      },
      handleClose (done) {
        done();
      },
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
